<template>
  <div>
    <a-card :tab-list="tabList" :active-tab-key="currentTab" @tabChange="tabChange">
      <div v-if="currentTab == 'pickingTaskPanel'">
        <picking-task-panel></picking-task-panel>
      </div>
      <div v-else-if="currentTab == 'pickingRecordPanel'">
        <picking-record-panel></picking-record-panel>
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  components: {
    PickingTaskPanel: () => import("./PickingTaskPanel/index"),
    PickingRecordPanel: () => import("./PickingRecordPanel/index"),
  },
  data() {
    return {
      tabList: [
        {
          key: "pickingTaskPanel",
          tab: this.$t("拣货任务"),
        },
        {
          key: "pickingRecordPanel",
          tab: this.$t("拣货记录"),
        },
      ],
      currentTab: "pickingTaskPanel",
    };
  },
  methods: {
    initData() {
      let currentTab = this.$route.query.currentTab;
      if (currentTab) {
        this.currentTab = currentTab;
      } else {
        this.currentTab = this.tabList[0].key;
        this.$router.push({ query: { currentTab: this.currentTab } });
      }
    },
    tabChange(key) {
      this.currentTab = key;
      this.$router.push({ query: { currentTab: this.currentTab } });
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
